// extracted by mini-css-extract-plugin
var _1 = "BookChapterModal__content--gOel5";
var _2 = "BookChapterModal__shadow--MPLAf";
var _3 = "BookChapterModal__shadowAdj--Nm3dU BookChapterModal__shadow--MPLAf";
export { _1 as "content", _2 as "shadow", _3 as "shadowAdj" }
